import request from '@/request'
import store from '@/store'
/**
 * 获取权限列表
 * @param data 11
 * @returns {AxiosPromise}
 */
export function getRoleApi(data) {
  return request({ url: '/api/v1/role/list', method: 'get', params: data })
}
/**
 * 删除角色组
 * @returns {AxiosPromise}
 */
export function role_del(data) {
  return request({ url: '/api/v1/role/del', method: 'POST', data: data })
}
/**
 * 修改角色组
 * @param data
 * @returns {AxiosPromise}
 */
export function role_modify(data) {
  return request({ url: '/api/v1/role/modify', method: 'POST', data: data })
}

/**
 * 获取地区树结构
 * @returns {AxiosPromise}
 */
export function get_area_tree() {
  // 保存到 vuex 中
  const list = store.getters.areaTree
  if (list.length === 0) {
    const url = '/api/v1/area/get_tree'
    return request({ url, method: 'GET' }).then((res) => {
      store.commit('SET_AREA_TREE', res.areaTree)
      return res
    })
  } else {
    return new Promise((resolve) => {
      resolve({ areaTree: list, msg: '缓存中的数据', code: 1 })
    })
  }
}

/**
 * 获取用户列表
 * @param params
 * @returns {AxiosPromise}
 */
export function get_admin_list(params) {
  return request({ url: '/api/v1/admin/list', method: 'GET', params: params })
}

/**
 * 修改用户状态
 * @param data
 * @returns {AxiosPromise}
 */
export function modify_status(data) {
  return request({
    url: '/api/v1/admin/modify_status',
    method: 'POST',
    data: data,
  })
}

/**
 * 设置管理
 * @param data
 * @returns {AxiosPromise}
 */
export function set_major(data) {
  return request({
    url: '/api/v1/admin/set_major',
    method: 'POST',
    data: data,
  })
}

/**
 * 修改用户
 * @param data
 * @returns {AxiosPromise}
 */
export function modify_admin(data) {
  return request({
    url: '/api/v1/admin/modify',
    method: 'POST',
    data: data,
  })
}
